import { Outlet } from "react-router-dom";

// Components
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

// Styles
import classes from "./RootLayout.module.css";

export default function RootLayout() {
  return (
    <div className={classes["root-layout"]}>
      <NavBar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
